import { render, staticRenderFns } from "./statusIndicatorWithWordsV2.vue?vue&type=template&id=1f30a0e6&scoped=true"
import script from "./statusIndicatorWithWordsV2.vue?vue&type=script&lang=js"
export * from "./statusIndicatorWithWordsV2.vue?vue&type=script&lang=js"
import style0 from "./statusIndicatorWithWordsV2.vue?vue&type=style&index=0&id=1f30a0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f30a0e6",
  null
  
)

export default component.exports